import { render, staticRenderFns } from "./JobTitlesForm.vue?vue&type=template&id=0228c8f1"
import script from "./JobTitlesForm.vue?vue&type=script&lang=ts"
export * from "./JobTitlesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports